import axios from "axios";

export default function getTicket({ id }) {
  return new Promise((resolve, reject) =>
    axios
      .get(`/support/api/v1/admin/tickets/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
